import { Navigate } from "react-router-dom";
import { getPrivileges } from "utils/generalUtils";
import { decryptStorage } from "utils/utils";
import { ConsultPrivileges } from "config/configRoutes";
export const ProtectedDashboard = ({
    redirectPath = "/logout",
    redirectProyT = "/dashboards",
    redirectClient = "/clientSection",
    redirectChecker = "/verificationSection",
    redirectMyself = "/Myself",
    redirectRoles = "/Roles",
    redirectUsers = "/Usuarios",
    redirectLocation = "/Ubicaciones",
    redirectOtherProducts = "/RequestManagement",
    redirectLogistic = "/Logistica",
    redirectAgreements = "/Convenios",
    children,
}) => {
    const token = decryptStorage(localStorage.getItem('token'))
    const permisions = JSON.parse(decryptStorage(localStorage.getItem("dataUser")));

    if (!token) {
        return <Navigate to={redirectPath} replace />;
    }
    if (getPrivileges(permisions.role, ConsultPrivileges.proyTconsultPrivileges)) {
        return <Navigate to={redirectProyT} replace />;
    }
    if (getPrivileges(permisions.role, ConsultPrivileges.suscriberConsultPrivilege)) {
        return <Navigate to={redirectClient} replace />;
    }
    if (getPrivileges(permisions.role, ConsultPrivileges.checkerConusltPrivilege)) {
        return <Navigate to={redirectChecker} replace />;
    }
    if (getPrivileges(permisions.role, ConsultPrivileges.myselfConusltPrivilege)) {
        return <Navigate to={redirectMyself} replace />;
    }
    if (getPrivileges(permisions.role, ConsultPrivileges.consultUser)) {
        return <Navigate to={redirectUsers} replace />;
    }
    if (getPrivileges(permisions.role, ConsultPrivileges.consultRole)) {
        return <Navigate to={redirectRoles} replace />;
    }
    if(getPrivileges(permisions.role, ConsultPrivileges.locationList)){
        return <Navigate to={redirectLocation} replace />;
    }
    if(getPrivileges(permisions.role, ConsultPrivileges.otherProductsConsult)){
        return <Navigate to={redirectOtherProducts} replace />;
    }
    if(getPrivileges(permisions.role, ConsultPrivileges.logisticRoutes)){
        return <Navigate to={redirectLogistic} replace />;
    }
    if(getPrivileges(permisions.role, ConsultPrivileges.supervisorConsult)){
        return <Navigate to={redirectAgreements} replace />;
    }
    return children;
};